import { MutationTree } from 'vuex';
import { SoundState } from './types';

export const mutations: MutationTree<SoundState> = {

    setCallSounds: (state, data) => {
        state.callSounds = data;
    },
    setIvrMenu: (state, data) => {
        state.ivrMenu = data;
    },
};